<template>
  <div class="Leaflet">
    <!-- <v-card class="px-2" style="z-index: 9999">
      <v-expansion-panel
        v-model="panel"
        expand
        popout
      >
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-card-title class="title">
              Aplicar Filtros
            </v-card-title>
          </template>

          <v-card>
            <v-card-text>
              <v-layout wrap justify-space-between>
                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuIni"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicial"
                      v-model="dateIni"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser anterior a la fecha final"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateIni"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-spacer/>

                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuEnd"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Final"
                      v-model="dateEnd"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser posterior a la fecha inicial"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateEnd"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-spacer/>
              </v-layout>

              <v-layout row wrap v-if="filterBy">
                <v-flex xs12 v-for="(filt, index) in filterBy" :key="filt.id">
                  <v-autocomplete
                    :items="filt.choices"
                    :label="'Filtrar por ' + filt.label"
                    v-model="filter[index]"
                    :disabled="loading"
                    color="secondary"
                    item-text="label"
                    item-value="id"
                    hide-no-data
                    hint="Vacio para no filtrar"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="warning"
          :disabled="loading"
          @click="clear()"
        >
          Limpiar
        </v-btn>
        <v-btn color="info"
          :disabled="loading || vDate"
          @click="getMarkersWhithFilter()"
        >
          Cargar Mapa
        </v-btn>
      </v-card-actions>

      <v-card-actions>
        <v-btn
          color="info"
          @click="showLongText"
        >
          Toggle long popup
        </v-btn>

        <v-btn
          color="info"
          :disabled="loading"
          @click="clustering = !clustering"
        >
          Toggle cluster
        </v-btn>

        <v-btn
          color="info"
          @click="loadGeo()"
        >
          loadGeo
        </v-btn>

        <v-btn color="primary"
          :disabled="loading"
          @click="getAllFeatures()"
        >
          <v-icon left>cloud_download</v-icon>
          Localidades
        </v-btn>

        <v-btn color="warning"
          :disabled="loading"
          @click="cleanFeatures()"
        >
          <v-icon left>delete_forever</v-icon>
          Localidades
        </v-btn>

        <v-btn color="info"
          :disabled="loading"
          @click="printSelected()"
        >
          Selected
        </v-btn>
      </v-card-actions>
    </v-card> -->

    <v-card-text
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        :size="progressSize"
        :width="progressWidth"
        :value="completed"
        color="info"
      >
        {{ progressAdvance }}
        {{ progressTotal }}
      </v-progress-circular>
    </v-card-text>

    <!-- <v-card v-else>
      <v-card-text>
        <p>First marker is placed at {{ withPopup.lat }}, {{ withPopup.lng }}</p>
        <p>Center is at {{ currentCenter }} and the zoom is: {{ currentZoom }}</p>
      </v-card-text>
    </v-card> -->

    <div style="height: 90vh; width: 100%" v-else>
      <l-map
        class="l-map"
        :zoom="zoom"
        maxNativeZoom=18
        :center="center"
        :options="mapOptions"
        style="height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
          :options="tileOptions"
        />
        <l-control-scale position="topright" :imperial="false" :metric="true"></l-control-scale>

        <!-- <l-geo-json :geojson="geojson"></l-geo-json> -->

        <l-geo-json :geojson="localidades" :options="geoOptions"></l-geo-json>

        <!-- <l-marker :lat-lng="withPopup">
          <l-popup>
            <div @click="innerClick">
              I am a popup
              <p v-show="showParagraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
                Donec finibus semper metus id malesuada.
              </p>
            </div>
          </l-popup>
        </l-marker>

        <l-marker :lat-lng="withTooltip">
          <l-tooltip :options="{ permanent: true, interactive: true }">
            <div @click="innerClick">
              I am a tooltip
              <p v-show="showParagraph">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
                Donec finibus semper metus id malesuada.
              </p>
            </div>
          </l-tooltip>
        </l-marker> -->

        <l-layer-group ref="features">
          <l-popup>
            <span @click="innerClick()"> Encuesta id: <br> {{caller}}</span>

            <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p>
          </l-popup>
        </l-layer-group>

        <template v-if="clustering">
          <l-marker-cluster :options="clusterOptions">
            <l-marker v-for="mark in markers" :key="mark.id"
              :lat-lng="LatLongPoint(mark.coordenadas[1], mark.coordenadas[0])"
              @click="openPopUp(LatLongPoint(mark.coordenadas[1], mark.coordenadas[0]), mark.id)"
            >
            </l-marker>
          </l-marker-cluster>
        </template>

        <template v-else>
          <l-marker v-for="mark in markers" :key="mark.id"
            :lat-lng="LatLongPoint(mark.coordenadas[1], mark.coordenadas[0])"
            @click="openPopUp(LatLongPoint(mark.coordenadas[1], mark.coordenadas[0]), mark.id)"
          >
          </l-marker>
        </template>

      </l-map>
    </div>

    <!-- <v-card>
      <pretty-json
        :data="selectedLoc"
      ></pretty-json>
    </v-card> -->
  </div>
</template>

<script>
// import JsonPretty from 'vue-json-pretty'
import moment from 'moment'

import 'leaflet/dist/leaflet.css'
import { latLng, Icon } from 'leaflet'
import { LMap, LTileLayer, LLayerGroup, LControlScale, LMarker, LPopup, LGeoJson } from 'vue2-leaflet'
// import { LMap, LTileLayer, LLayerGroup, LControlScale, LMarker, LPopup, LTooltip, LGeoJson } from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  name: `Leaflet`,

  components: {
    // 'pretty-json': JsonPretty,
    LMap,
    LTileLayer,
    LLayerGroup,
    LControlScale,
    LMarker,
    LPopup,
    // LTooltip,
    LGeoJson,
    'l-marker-cluster': Vue2LeafletMarkerCluster
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    // this.loadFiltro()
    this.getMarkersWhithFilter()
  },

  data: function () {
    return {
      backConf: {
        path: '/briefcase/localizacion',
        pathFiltro: '/charts/resumen_enc',
        pathHome: '/maps/localidad/?page=',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      filter: [],

      filterBy: null,
      alert: false,

      markers: [],

      // Leaflet
      zoom: 7,
      center: latLng(4.60971, -74.08175),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(4.60871, -74.11379),
      withTooltip: latLng(4.60971, -74.08175),
      currentZoom: 7,
      currentCenter: latLng(4.60971, -74.08175),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 23
      },
      tileOptions: {
        maxZoom: 23,
        maxNativeZoom: 19
      },
      geojson: null,

      clustering: true,
      clusterOptions: {},

      localidades: null,

      popupName: null,
      geoOptions: {
        style: function style (feature) {
          // return {
          //   weight: 4,
          //   opacity: 0.7,
          //   color: '#666',
          //   fillOpacity: 0.3
          // };

          // let loc = feature.id
          // if (loc < 8) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#ff0000',
          //     fillOpacity: 0.3
          //   }
          // } else if (loc < 15) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#00ff00',
          //     fillOpacity: 0.3
          //   }
          // } else {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#0000ff',
          //     fillOpacity: 0.3
          //   }
          // }

          // if (feature.properties.selected) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#ff0000',
          //     fillOpacity: 0.3
          //   };
          // } else {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#0080FF',
          //     fillOpacity: 0.3
          //   };
          // }
        },
        onEachFeature: (feature, layer) => {
          layer.on({
            click (e) {
              e.target.feature.properties.selected = !e.target.feature.properties.selected
              if (e.target.feature.properties.selected) {
                layer.setStyle({ opacity: 1, width: 3, fillColor: '#ff0000' })
              } else {
                layer.setStyle({ opacity: 1, width: 3, fillColor: '#0080FF' })
              }
            }
            // mouseover(e){
            //   this.setStyle({
            //     fillColor: '#ff0000',
            //     color: '#ff0000'
            //   });
            // },
            // mouseout(e){
            //   this.setStyle({
            //     fillColor: '#bf9946',
            //     color: '#bf9946'
            //   });
            // }
          })

          // var self = this;
          // layer.on('mouseover', function(e) {
          // self.popupName = feature.properties.Name;
          // // console.log(feature.properties.Name);
          // //open popup
          // var popup = L.popup()
          //   .setLatLng(e.latlng)
          //   .setContent('<h1 style="color: grey; margin-bottom: 0;">'+ feature.properties.Name +'</h1>')
          //   .openOn(self.$refs.myMapRef.mapObject)
          // })
        }
      },

      caller: null,
      selectedLoc: []
    }
  },

  watch: {
    '$store.state.actualProject': function () {
      this.operativo = this.$store.state.actualProject.id
    },

    /**
     * Calcula el porcentaje de avacne
     * @return {float} porcentaje de avance
     */
    'markers': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {boolean} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
     */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    }

    // selectedLoc: function selectedLoc () {
    //   let selected = []
    //
    //   this.localidades.features.forEach(function(loc, index) {
    //     if (loc.properties.selected){
    //       console.log(index, loc.properties.nombre, loc.properties.selected)
    //       selected.push(loc.properties.nombre)
    //     }
    //   })
    //
    //   return selected
    // }
  },

  methods: {
    /**
     * Limpia el arreglo de marcadores actual y llama a la función que realiza el get
     */
    getMarkersWhithFilter () {
      this.markers = []
      this.alert = false
      this.getMarkers()
    },

    /**
     * Carga los puntos requeridos para los markers en la variable features
     */
    getMarkers () {
      this.loading = true
      this.panel = [false]
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          filtro: this.filterToApply,
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.markers.length

          t.markers = t.markers.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getMarkers()
          } else {
            // console.log('getMarkers', t.markers.length, t.progressTotal, t.progressAdvance)
            t.backConf.page = 1
            t.progressTotal = 0
            t.progressAdvance = 0
            // t.loadFeatures()
            t.loading = false
          }

          console.log('markest:')
          console.log(t.markers)
        })
        .catch(function (err) {
          t.markers = []
          // t.loadFeatures()
          t.alert = true
          t.loading = false
          t.backConf.page = 1
          t.mapkey += 1
          console.error(err)
        })
    },

    // loadFeatures () {
    //   this.loading = true
    //   let t = this
    //   let lon = []
    //   let lat = []
    //
    //   console.log('loadFeatures')
    //
    //   this.markers.forEach(function (element) {
    //     let mark = {
    //       'type': 'Feature',
    //       'id': element.id,
    //       'properties': {},
    //       'geometry': {
    //         'type': 'Point',
    //         'coordinates': element.coordenadas
    //       }
    //     }
    //     // FIXME Solucionar la cantidad de elementos cargados
    //     t.features.push(mark)
    //
    //     // Crea arreglos de latitudes y longitudes (como strings)
    //     lon.push(element.coordenadas[0].toString())
    //     lat.push(element.coordenadas[1].toString())
    //   })
    //   // Ordena latitudes y longitudes
    //   lon.sort()
    //   lat.sort()
    //
    //   // Selecciona el valor central de latitud y longitud
    //   this.mapViewConf.center[0] = parseFloat(lon[Math.trunc(lon.length / 2)])
    //   this.mapViewConf.center[1] = parseFloat(lat[Math.trunc(lat.length / 2)])
    //
    //   this.mapkey += 1
    //   this.loading = false
    // },

    /**
     * Carga los filtros especificos
     */
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.pathFiltro,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.filter = []
    },

    // Leaflet
    zoomUpdate (zoom) {
      this.currentZoom = zoom
    },
    centerUpdate (center) {
      this.currentCenter = center
    },
    showLongText () {
      this.showParagraph = !this.showParagraph
    },
    innerClick () {
      alert('Click!')
    },

    LatLongPoint (lat, long) {
      return latLng(lat, long)
    },

    async loadGeo () {
      const response = await fetch('https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson')
      this.geojson = await response.json()
    },

    openPopUp (latLng, caller) {
      this.caller = caller
      this.$refs.features.mapObject.openPopup(latLng)
    },

    // del home
    cleanFeatures () {
      this.localidades = null
    },

    getAllFeatures () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathHome,
        params: {
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.localidades = resp.data.results
          t.loading = false
        })
        .catch(function (err) {
          t.localidades = null
          t.loading = false
          console.error(err)
        })
    },

    // pruebas
    printSelected () {
      console.log('Selected')
      this.localidades.features.forEach(function (loc, index) {
        if (loc.properties.selected) {
          console.log(index, loc.properties.nombre, loc.properties.selected)
          this.selectedLoc.push(loc.properties.nombre)
        }
      }, this)
      console.log(JSON.stringify(this.selectedLoc))
    }
  }
}
</script>

<style scoped>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  /* .Leaflet {
    text-align:left;
    height:85%;
    width:100%;
    position: absolute;
  } */
  /* .l-map {
    overflow:hidden;
    background:none!important;
    height:100%;
    width:100%;
  } */
  /* .totalMarks {
    position: absolute;
    top: 3px;
    left: 29px;
  } */
</style>
